<section class="main-menu container">
  <ng-scrollbar #ps track="all" appearance="compact">
    <app-menu-items [ps]="ps" [isEyeServiceEnabled]="false" />
  </ng-scrollbar>
</section>
